<template>
    <div :ref="name">
        <div :ref="name + '-content-preloader'" class="content-preloader" :style="'height: ' + height + 'px'">

        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "async-card",
    props: {
        name: {
            type: String,
        },

        url: {
            type: String
        },

        height: {
            type: Number,
            default: 280,
        },

        method: {
            type: String,
            default: null
        },

        afterScript: {
            type: String,
            default: null
        }
    },

    mounted: function () {
        let axios = require('axios');
        let self = this

        let config = {
            method: 'get',
            url: self.url,
            headers: { }
        };

        axios(config)
            .then(function (response) {
                self.$refs[self.name].innerHTML = response.data
                if (self.method) {
                    window[self.method]()
                }

                if (self.afterScript) {
                    let scripts = JSON.parse(self.afterScript)
                    for (let script in scripts) {
                        window[scripts[script]]()
                    }
                }
            })
            .catch(function (error) {
                self.$refs[self.name + '-content-preloader'].innerHTML =
                    "<h4>" +
                    "Obsah se nepodařilo načíst" +
                    "<br>" +
                    "<small><i>" + self.name + "</i></small>" +
                    "</h4>"
                console.log(error)
            });
    }
}
</script>

<style scoped>
    .content-preloader >>> h4 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }
</style>
